import { Column } from "@components/Layout";
import { styled } from "solid-styled-components";

export const MapWrapper = styled(Column)`
  .marker {
    width: 25px;
    height: 25px;
    & > div {
      display: none;
      width: max-content;
      height: max-content;
    }
  }
  .show {
    & > div {
      display: block;
    }
  }
`;
